import React, { useState } from "react"
import styled from "@emotion/styled"
import { ThemeProvider } from "@emotion/react"
import { useThemeUI, Button, IconButton } from "theme-ui"
// import navLinks from './navLinks'
import MobileSubmenu from "./mobileSubmenu"
import { FiMenu } from "@react-icons/all-files/fi/FiMenu"
import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft"
import * as componentStyle from "assets/css/components.module.css"
import { useStaticQuery, graphql } from "gatsby"
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion"
import "assets/css/accordion.css"

const MenuHeader = styled.div`
    width: 100vw;
    padding: 16px 32px;
    font-size: 1.5em;
    font-weight: bold;
    background: #d9d9d9;
`
const BackButton = styled.div`
    width: 100vw;
    padding: 8px 16px;
    background: #f7f7f7;
    border-bottom: 2px solid ${(props) => props.theme.colors.muted};
`
const MobileMenu = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 101;
    background-color: #f7f7f7;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 0 15px;
    overflow-y: hidden;
    -webkit-transform: translate3d(-100%, 0, 0);
    -moz-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    transition: 0.5s all;
    &[data-active="true"] {
        -webkit-transform: translate3d(0, 0, 0);
        -moz-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    ul,
    li {
        list-style: none;
        padding: 0;
        margin: 0;
        width: 100%;
    }

    .accordion__button {
        background: unset;
        border: unset;
        padding: 16px 32px 16px 16px;
        font-size: 17px;
        text-transform: uppercase;
        font-weight: normal;
        color: ${(props) => props.theme.colors.secondary};

        &:hover {
            border-color: transparent;
            color: ${(props) => props.theme.colors.background};
            background: ${(props) => props.theme.colors.blue1};
        }
        &:after {
            height: 7px;
            width: 7px;
            right: 0.7rem;
        }
    }
    & .accordion__item {
        margin-bottom: 0;
        border: unset;
    }
`

const MobileNav = () => {
    const context = useThemeUI()
    const { theme } = context
    const [visible, setVisible] = useState(false)
    const menu = useStaticQuery(menuQuery)
    const navLinks = menu.strapiMenu.sub_menus.sort(function (a, b) {
        return a.section - b.section
    })

    const toggleVisibility = () => {
        setVisible(!visible)
    }

    return (
        <ThemeProvider theme={theme}>
            <IconButton
                sx={{
                    backgroundColor: "#F7F7F7",
                    color: "blue1",
                    pt: 2,
                    pb: 1,
                    px: 2,
                    cursor: "pointer",
                }}
                onClick={toggleVisibility}
            >
                <span className={componentStyle.iconsMedium}>
                    <FiMenu />
                </span>
            </IconButton>
            <MobileMenu
                aria-hidden={!visible}
                data-active={visible}
                id="my-menu"
            >
                <BackButton>
                    <Button
                        variant="buttons.mobile"
                        sx={{
                            backgroundColor: "#F7F7F7",
                            color: "blue1",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                        onClick={toggleVisibility}
                    >
                        <span className={componentStyle.iconsSmall}>
                            <FiArrowLeft />
                        </span>{" "}
                        &nbsp;BACK
                    </Button>
                </BackButton>
                <MenuHeader>Main Menu</MenuHeader>
                <ul>
                    {navLinks.map((linkItem, index) => {
                        if (linkItem.submenu && linkItem.submenu.length > 0) {
                            return (
                                <Accordion key={index} allowZeroExpanded>
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                {linkItem.displayname ||
                                                    linkItem.name}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <MobileSubmenu
                                                linkItem={linkItem}
                                                linkIndex={index}
                                            />
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>
                            )
                        } else {
                            return (
                                <MobileSubmenu
                                    key={index}
                                    linkItem={linkItem}
                                    linkIndex={index}
                                />
                            )
                        }
                        //     <Accordion allowZeroExpanded>
                        //     {data.map((item, index) => (
                        //         <AccordionItem key={index}>
                        //             <AccordionItemHeading>
                        //                 <AccordionItemButton>
                        //                     {item.title}
                        //                 </AccordionItemButton>
                        //             </AccordionItemHeading>
                        //             <AccordionItemPanel>
                        //                 <div
                        //                     dangerouslySetInnerHTML={{
                        //                         __html: item.content,
                        //                     }}
                        //                 ></div>
                        //             </AccordionItemPanel>
                        //         </AccordionItem>
                        //     ))}
                        // </Accordion>
                        // return (
                        //     // <MobileSubmenu
                        //     //     key={index}
                        //     //     linkItem={linkItem}
                        //     //     linkIndex={index}
                        //     // />
                        // )
                    })}
                </ul>
            </MobileMenu>
        </ThemeProvider>
    )
}

export default MobileNav

const menuQuery = graphql`
    {
        strapiMenu(
            menu_type: { eq: "header" }
            company: { shortname: { eq: "WNS" } }
            sub_menus: {}
        ) {
            sub_menus {
                menu
                name
                displayname
                section
                submenu {
                    id
                    link
                    name
                    section
                    childmenu {
                        id
                        link
                        name
                    }
                }
                url
            }
            name
        }
    }
`
